// extracted by mini-css-extract-plugin
export default {"dot":"notices-count-badge_dot__q23Fm","count":"notices-count-badge_count__NLMYf"};